//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import list from "./list/index";
import maps from "./list/map";
import category from "./list/category";
export default {
  name: "index",
  components: {
    list: list,
    maps: maps,
    category: category
  },
  data: function data() {
    return {
      activeName: '1'
    };
  },
  created: function created() {},
  methods: {
    handleSelect: function handleSelect(key) {
      this.activeName = key;
    }
  }
};